<template>
    <div class="toolsActivityEdit bgc">
        <div class="topText"><i class="el-icon-warning"></i> 请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容，我们保有依据国家规定及平台规则进行处理的权利。</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <!--基本信息-->
            <div class="activityMsgBox">
                <div class="title"><p>基本信息</p></div>
                <div class="contentBox">
                    <div class="left">
                        <el-form-item label="试题分类">
                            <span class="classType">{{typeName}}</span>
                            <el-button @click="selectType">选择分类</el-button>
                        </el-form-item>
                        <el-form-item label="试卷名称" prop="name">
                            <el-input v-model="ruleForm.name" maxlength="40" placeholder="请输入试卷名称(不超过40个字)"></el-input>
                        </el-form-item>
                        <el-form-item label="试卷封面" required class="posterImg">
                            <div class="imgBoxCode mechImg">
                                <i class="el-icon-picture" v-if="!ruleForm.bannerlogourl"></i>
                                <img class="activityCoverImage" :src="ruleForm.bannerlogourl.furl + '?' + time" v-else-if="ruleForm.bannerlogourl && ruleForm.bannerlogourl.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox" style="width: 400px">
                                <UploadFile :uploadType="uploadVideoType" @setFile="setBannerFile" :fileRule="fileRule" ></UploadFile>
                                <p>建议尺寸750*420px，JPG、PNG格式， 图片小于5M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="试卷详情">
                            <uEditor :content="ruleForm.description" ref="uEditor1" @getUEditorContent="getTrySeeContent"></uEditor>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <!--试卷设置-->
            <div class="activityMsgBox">
                <div class="title"><p>试卷设置</p></div>
                <div class="contentBox">
                    <div class="left">
                        <el-form-item label="试卷状态" prop="status"  class="onLineSet">
                            <el-select v-model="ruleForm.status" placeholder="请选择">
                                <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="考试时长"  prop="examlength" class="onLineSet">
                            <div class="examinationTime">
                                <el-input v-model="ruleForm.examlength"></el-input>
                                <span>分</span>
                            </div>
                            <div style="color: #999;line-height: 25px">0分钟，表示无限制。</div>
                        </el-form-item>
                        <el-form-item label="答案显示设置"  class="onLineSet">
                            <p style="color: #F56C6C">可选是否让学员在考试结束后看到答案解析，以及可以在何时看到答案解析</p>
                            <div class="examinationTime">
                                <el-radio-group v-model="ruleForm.answerdisplaytype">
                                    <el-radio :label="1">提交考试后显示</el-radio>
                                    <el-radio :label="2">提交并批改后显示</el-radio>
                                    <el-radio :label="3">全部隐藏</el-radio>
                                </el-radio-group>
                            </div>
                        </el-form-item>
                        <el-form-item label="试题设置"  class="onLineSet" prop="quescountbypage">
                            <div class="examinationTime">
                                <span style="padding-right: 10px">每页</span>
                                <el-input v-model="ruleForm.quescountbypage" placeholder="请输入整数"></el-input>
                                <span>题</span>
                                <span class="fen">（建议一页一题）</span>
                            </div>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <el-form-item class="btnBox">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="submitForm(ruleForm)">提交</el-button>
            </el-form-item>
        </el-form>
        <creatAlert ref="creatAlert"></creatAlert>
        <SelectClassPop ref="selectClassPop" @getClassInfo="getClassInfo"></SelectClassPop>
    </div>
</template>
<script>
    import UploadFile from 'base/upload/uploadFile2'
    import UEditor from 'base/uEditor/uEditor2'
    import SelectClassPop from 'views/questionbank/components/SelectClassPop'  //引用选择分类
    import creatAlert from './components/creatAlert' //引用创建成功弹窗
    import {saveOrUpdateExampaperInfo,getExampaperInfo} from 'api/testPaperApi'
    import {getAllHostcatalog} from 'api/questionApi'
    import {mapGetters, mapActions} from 'vuex'
    import { format } from 'path'
    export default {
        name: 'TestpaperEdit',
        data() {
            return {
                statusList: [ //状态
                    {label:'待发布',value:'1'},
                    {label:'已发布',value:'2'},
                ],
                typeName: this.$route.query.classname ? this.$route.query.classname : '未分类',
                cateid: this.$route.query.classId ? this.$route.query.classId : '', // 试题分类Code
                item:{
                    onlinetype: 1, // 上架方式
                },
                radio:1,
                time:'',
                ruleForm:{
                    innerid:'', //试卷id,
                    name:'', //试卷名称,
                    description:'', //试卷详情
                    examlength:'', //考试时长,
                    bannerlogourl:'', //封面图,
                    status:'已发布', //状态 1待发布 2 已发布
                    answerdisplaytype:1, //答案设置,
                    quescountbypage:'', //每页多少题,
                },
                uploadVideoType: {
                    catecode: '95',
                    datatype: 'IMAGE'
                },
                uploadType: {
                    catecode: '95',
                    datatype: 'IMAGE'
                },
                fileRule: {
                    btnName: '选择文件',
                    cls: '',
                    accept: '.jpg,.jpeg,.png',
                    size: 2,
                    width: '750',
                    height: '420'
                },
                rules: {
                    name: [
                        {required: true, message: '请输入试卷名称', trigger: 'blur'},
                        {max: '16', message: '不超过16字',  trigger: 'blur'}
                    ],
                    quescountbypage: [
                        {required: true, message: '请输入整数', trigger: 'blur'},
                    ],
                    status: [
                        {required: true, message: '请选择试卷状态', trigger: 'change'},
                    ],
                    examlength: [
                        {required: true, message: '请输入考试时长', trigger: 'blur'},
                    ],
                }
            }
        },
        created() {
        },
        mounted() {
            if(this.$route.query.type==='edit') {
                this._getInfo()
            }
        },
        methods: {
            getClassInfo(id, name) {
                this.typeName = name
                this.cateid=id
            },
            // 选择分类
            selectType() {
                this.setLoading(true);
                let params = {
                    catetype: 2,
                    showdefault: 1
                };
                getAllHostcatalog({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        // this.classInfoData = [
                        //     {label: data.data.label, id: data.data.id, datacount: data.data.datacount, children: data.data.content}
                        // ]
                        // this.classInfoData =
                        this.$refs.selectClassPop.openDialog([data.data])
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false)
                    }
                })
            },

            // 获取试卷信息
            _getInfo(){
                // this.setLoading(true);
                // if(this.$route.query.id){
                    let params={
                        innerid:this.$route.query.id
                    }
                    console.log(params)
                    getExampaperInfo({
                        data:params,
                        success: data => {
                            this.setLoading(false);
                            this.ruleForm=data.data;
                            this.ruleForm.bannerlogourl=JSON.parse(data.data.coverurl);
                            this.cateid=data.data.cateid;
                            this.typeName=data.data.catename
                            this.ruleForm.answerdisplaytype=parseInt(this.ruleForm.answerdisplaytype)
                            this.$refs.uEditor1.init(this.ruleForm.description)
                        },
                        error: data => {
                            this.setLoading(false);
                        }
                    })
                // }else{
                //     this.ruleForm='';
                // }
            },
            // uEditor内容展示
            getTrySeeContent(content) {
                this.ruleForm.description = content
            },
            // 提交信息
            submitForm(data){
                if(data.innerid){
                    //编辑
                    this._edit()
                }else{
                    // 新增
                    this._add()
                }
            },
            // 新增
            _add(){
                if(this.ruleForm.name==''){
                    this.$message.error('请输入试卷名称')
                    return
                }else if(this.ruleForm.bannerlogourl==''){
                    this.$message.error('请选择试卷封面')
                    return
                }else if(this.ruleForm.status==''){
                    this.$message.error('请选择试卷状态')
                    return
                }else if(this.ruleForm.examlength==''){
                    this.$message.error('请输入考试时长')
                    return
                }else if(this.ruleForm.quescountbypage==''){
                    this.$message.error('请输入每页题数')
                    return
                }
                this.setLoading(true);
                let coverurl = JSON.stringify(this.ruleForm.bannerlogourl);
                let params= {
                    catecode:this.cateid?this.cateid:0,
                    name:this.ruleForm.name,
                    description:this.ruleForm.description,
                    examlength:this.ruleForm.examlength,
                    coverurl:coverurl,
                    status:this.ruleForm.status=='已发布'?2:1,
                    answerdisplaytype:this.ruleForm.answerdisplaytype,
                    quescountbypage:this.ruleForm.quescountbypage,
                };
                saveOrUpdateExampaperInfo({
                    data: params,
                    success: data => {
                        this.setLoading(false);
                        console.log(data);
                        this.$refs.creatAlert.openDialog(data.data)
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            // 编辑
            _edit(){
                this.setLoading(true);
                let coverurl = JSON.stringify(this.ruleForm.bannerlogourl);
                let params= {
                    innerid:this.$route.query.id,
                    catecode:this.cateid,
                    name:this.ruleForm.name,
                    description:this.ruleForm.description,
                    examlength:this.ruleForm.examlength,
                    coverurl:coverurl,
                    status:this.ruleForm.status,
                    answerdisplaytype:this.ruleForm.answerdisplaytype,
                    quescountbypage:this.ruleForm.quescountbypage,
                };
                saveOrUpdateExampaperInfo({
                    data: params,
                    success: data => {
                        this.setLoading(false);
                        console.log(data);
                        this.$router.go(-1)
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            cancel() {
                this.$router.go(-1)
            },
            setFile(file) {
                this.ruleForm.coveratturlid = file
                this.time = new Date().getTime()
            },
            setBannerFile(file) {
                delete file.type;
                this.ruleForm.bannerlogourl = file;
                this.time = new Date().getTime()
            },
            ...mapActions([
                'setLoading'
            ])
        },
        watch: {
        },
        components: {
            UploadFile, UEditor,SelectClassPop,creatAlert
        }
    }
</script>
<style lang="scss">
    @import "~common/scss/mixin";
    @import "~common/scss/base";
    .toolsActivityEdit{
        background: #fff;
        min-width: 1200px;
        .topText{
            width:100%;
            height:44px;
            line-height: 44px;
            background:rgba(253,246,236,1);
            border-radius:4px;
            color: #E6A23C;
            .el-icon-warning{
                padding-left: 20px;
                padding-right: 10px;
            }
        }
        .title{
            padding-bottom: 8px;
            p{
                border-left: 2px solid #409EFF;
                text-indent: 8px;
                font-size: 16px;
                font-weight: 500;
            }
        }
        .el-form{
            .el-form-item {
                .el-form-item__label{
                    text-align: left;
                    font-size: 14px;
                }
            }
            .imgBoxCode {
                float: left;
                margin-right: 10px;
                width: 120px;
                height: 120px;
                font-size: 64px;
                text-align: center;
                line-height: 120px;
                color: #DCDFE6;
                background: #F5F7FA;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .uploadFileBox {
                float: left;
            }
        }
        .activityMsgBox{
            .left{
                min-width: 850px;
                .mechImg{
                    width: 218px;
                    height: 128px;
                }
            }
        }
        .activityMsgBox{
            background: #fff;
            padding: 20px;
            .contentBox{
                padding-top: 20px;
                display: flex;
                // justify-content: space-between;
                .left{
                    .classType{
                        margin-right: 15px;
                    }
                    .cover,.posterImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .imgBox{
                                width: 318px;
                                height: 178px;
                                background: #F5F7FA;
                                text-align: center;
                                line-height: 178px;
                                .el-icon-picture{
                                    color: #DCDFE6;
                                    font-size: 40px;
                                }
                                .activityCoverImage{
                                    width: 318px;
                                    height: 178px;
                                }
                            }
                            .uploadFileBox{
                                margin-left: 12px;
                                .uploadFile{
                                    .upload-demo{
                                        .el-upload {
                                            .el-button{
                                                background: #fff;
                                                color: #000;
                                                border: 1px solid #C0C4CC;
                                            }
                                        }
                                    }
                                }
                                p{
                                    color: #909399;
                                    font-size: 14px;
                                    line-height: 35px;
                                }
                            }
                        }
                    }
                    .el-form-item{
                        .el-form-item__content{
                            .el-input{
                                width: 100%;
                            }
                            .el-date-editor{
                                .el-input__icon, .el-range-separator{
                                    line-height: 25px;
                                }
                            }
                            .mostTips{
                                color: #C0C4CC;
                            }
                            .showRankingListTips{
                                color: #909399;
                                margin-left: 20px;
                                position: relative;
                                top: 2px;
                            }
                        }
                    }
                    .date{
                        .el-form-item__label::after{
                            content: '*';
                            color: #F56C6C;
                            margin-left: 4px;
                        }
                        .el-form-item__content{
                            width: 500px;
                            .to{
                                margin: 0 13px;
                            }
                            .el-date-editor {
                                width: 180px;
                                .el-input__inner{
                                    padding-right: 0;
                                }
                            }
                        }
                    }
                    .examinationTime{
                        display: flex;
                        .el-input{
                            width: 120px!important;
                            padding-right: 10px;
                        }
                        .fen{
                            color: #999999;
                        }
                        .el-radio-group{
                            display: flex;
                            flex-direction: column;
                            .el-radio{
                                margin-top: 20px;
                            }
                        }
                    }
                }
            }
        }
        .el-radio__input.is-checked+.el-radio__label{
            color: #303133;
        }
        .btnBox{
            .el-form-item__content{
                margin-left: 0 !important;
                padding-left: 121px;
                background: #fff;
                height: 80px;
                line-height: 80px;
            }
        }
        .textareaSet {
            width: 400px;
            height: 117px;
            textarea {
                width: 100%;
                height: 100%;
            }
        }
    }
    /*文本框样式*/
    .el-textarea__inner{
        padding: 5px 40px 5px 15px;
    }
    .el-input__icon{
        line-height: 32px;
    }
    /*星号显示在右侧*/
    .el-form-item {
        .el-form-item__label {
            text-align: left
        }
        &.is-required {
            .el-form-item__label::after{
                content: "*";
                color: #F56C6C;
                margin-left: 4px;
            }
            .el-form-item__label::before {
                display: none;
            }
        }
    }
</style>
